<template>
  <b-performance-table
    :data="rows"
    :custom-headers="headers"
    :loading="loading"
    :show-diff="dates.compareWith"
    :data-grouped-by="groupBy"
  />
</template>

<script>
import { get } from 'vuex-pathify';
import fetchWindowTypeDataMixin from '@/components/mixins/fetch-window-type-data-mixin';
import EventBus from '@/adready-vue/helpers/global/event-bus';
import performanceDataMixin from '~/components/mixins/performance-data-mixin';
import { checkUserHasAiAssistant } from '~/util/utility-functions';

export default {
  name: 'DashDetailPublishersPerformanceList',
  components: {
    BPerformanceTable: () =>
      import(
        /* webpackChunkName: "b-performance-table" */ '~/components/elements/b-performance-table.vue'
      ),
  },

  mixins: [performanceDataMixin, fetchWindowTypeDataMixin],

  data() {
    return {
      loading: false,
      groupBy: 'publisher',
      userHasAiAssistant: false,
    };
  },
  computed: {
    selectedEvent: get('dashboard/GET_SELECTED_EVENT'),
    headers() {
      return [{ name: 'Name', sortKey: 'name' }, this.getCommonHeader()];
    },
    performance: get('dashboard/performance@publisher'),
    rows() {
      if (!this.performance) {
        return this.performance;
      }

      const rows = this.performance.map((item) => {
        const rowItem = this.transformToRowItem(item);
        rowItem.name = item.displayName || item.name;
        rowItem.imgSrc =
          item.imageUrl ||
          'https://storage.googleapis.com/flip-assets/publisher_logos/color/otherhub_80x80.png';
        rowItem.nameColumnStyle = 'both';
        rowItem.subText = item.streamingCategory;
        return rowItem;
      });

      return this.sortRows(rows);
    },
    currentUser: get('common/currentUser'),
  },
  created() {
    EventBus.$on('is-chatbot-clicked', this.handleIsChatbotClicked);
  },
  beforeDestroy() {
    EventBus.$off('is-chatbot-clicked', this.handleIsChatbotClicked);
  },
  async mounted() {
    try {
      if (
        !EventBus.isChatbotClicked ||
        (EventBus.performanceAPILoadedOnAIEnabled === false && EventBus.isChatbotClicked)
      ) {
        await this.loadPerformancePublisherData(this.payload);
      }
      this.userHasAiAssistant = checkUserHasAiAssistant(this.currentUser);
      if (this.userHasAiAssistant && EventBus.performanceAPILoadedOnAIEnabled === false) {
        this.loadAllPerformanceData(this.payload, 'publisher');
      }
    } catch (err) {
      console.error('error mounting DashDetailPublishersPerformanceList ->', err);
    }
  },
  methods: {
    async loadPerformanceData(payload) {
      await this.loadPerformancePublisherData(payload);
      if (this.userHasAiAssistant) {
        this.loadAllPerformanceData(payload, 'publisher');
      }
    },
    async handleIsChatbotClicked() {
      if (EventBus.performanceAPILoadedOnAIEnabled === false) {
        this.loadAllPerformanceData(this.payload, 'publisher');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .no-bg.zero {
  margin-top: 0 !important;
  margin-left: -10px !important;
}
</style>
